import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { adminGetAllUsers } from "../../api/admin";
import { UserList } from "./users-list";
import { UserDialog } from "./users-dialog";
import { User } from "../../pages/playground/types";
import { useAuthStore } from "../../authProvider";

export default function AuthorizationUsers() {
  const { user: currentUser } = useAuthStore();
  const [isLoading, setIsLoading] = useState(false);

  const [users, setUsers] = useState<User[]>([]);

  const [openUserDialog, setOpenUserDialog] = useState(false);
  const [userDialogUser, setUserDialogUser] = useState<User | null>(null);

  // Check if current user can manage users (ADMIN or MANAGER)
  const canManageUsers = currentUser?.isAdmin || currentUser?.isManager || false;

  const fetchUsers = async () => {
    try {
      setIsLoading(true);

      const response = await adminGetAllUsers();
      setUsers(response.data.data);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleDisableEnable = (userId: string, newDisabledState: boolean) => {
    // Update the user in the list to show the new disabled state
    setUsers((prevUsers) =>
      prevUsers.map((u) =>
        u.id === userId ? { ...u, disabled: newDisabledState } : u
      )
    );
  };

  return (
    <>
      {isLoading && <CircularProgress />}

      {!isLoading && (
        <UserList
          users={users}
          onAddUser={() => {
            setUserDialogUser(null);
            setOpenUserDialog(true);
          }}
          onEditUser={(user) => {
            setUserDialogUser(user);
            setOpenUserDialog(true);
          }}
          canManageUsers={canManageUsers}
        />
      )}

      <UserDialog
        open={openUserDialog}
        user={userDialogUser}
        onClose={(refresh) => {
          setOpenUserDialog(false);
          setUserDialogUser(null);

          if (refresh) {
            fetchUsers();
          }
        }}
        onDisableEnable={handleDisableEnable}
        canManageUsers={canManageUsers}
      />
    </>
  );
}
